/**
 * @generated SignedSource<<9d531e106d2b6b2f46e946691c632cec>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type assigneeGroupHeader_issueTableGrouping$data = {
  readonly displayName: string;
  readonly user: {
    readonly picture: AGG$URL;
  } | null | undefined;
  readonly " $fragmentType": "assigneeGroupHeader_issueTableGrouping";
};
export type assigneeGroupHeader_issueTableGrouping$key = {
  readonly " $data"?: assigneeGroupHeader_issueTableGrouping$data;
  readonly " $fragmentSpreads": FragmentRefs<"assigneeGroupHeader_issueTableGrouping">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "assigneeGroupHeader_issueTableGrouping",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "displayName"
    },
    {
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "picture"
        }
      ]
    }
  ],
  "type": "JiraJqlUserFieldValue"
};

(node as any).hash = "b0c0b208c554355360ef1df28176610c";

export default node;
